module.exports = __webpack_public_path__ + "img/whatsapp.edfa91c1.svg";